import { render, staticRenderFns } from "./SelectedLanguage.vue?vue&type=template&id=4b735f86&scoped=true&"
import script from "./SelectedLanguage.vue?vue&type=script&lang=js&"
export * from "./SelectedLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b735f86",
  null
  
)

export default component.exports